import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Grid,
  Paper,
  Alert,
  Snackbar,
  IconButton,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { addDocument } from '../../services/firestoreService';
import PatientSearch from '../PatientSearch';

const CasosAmbulatorios = () => {
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Estado del formulario
  const [formData, setFormData] = useState({
    patient: null,
    patientId: '',
  });

  const handlePatientSelect = (patient) => {
    setFormData({
      ...formData,
      patient: patient,
      patientId: patient?.patientId || patient?.id || ''
    });
  };

  const handleSave = async () => {
    if (!formData.patient) {
      setSnackbar({
        open: true,
        message: 'Por favor selecciona un paciente',
        severity: 'warning'
      });
      return;
    }

    try {
      setSaving(true);
      
      const dataToSave = {
        patientId: formData.patientId,
        patientName: formData.patient.name,
        type: 'ambulatorio',
        createdAt: new Date(),
        // Aquí se agregarán más campos cuando los añadas
      };

      await addDocument('codificacion_ambulatorios', dataToSave);
      
      setSnackbar({
        open: true,
        message: 'Caso ambulatorio guardado exitosamente',
        severity: 'success'
      });

      // Limpiar formulario
      setFormData({
        patient: null,
        patientId: '',
      });
    } catch (error) {
      console.error('Error guardando caso ambulatorio:', error);
      setSnackbar({
        open: true,
        message: 'Error al guardar el caso ambulatorio',
        severity: 'error'
      });
    } finally {
      setSaving(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Codificación de Casos Ambulatorios
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Completa el formulario para codificar un caso ambulatorio.
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid size={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                Paciente
              </Typography>
              {formData.patient && (
                <IconButton size="small" onClick={() => setFormData({ patient: null, patientId: '' })}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </Box>

            {!formData.patient ? (
              <PatientSearch
                onPatientSelect={handlePatientSelect}
                selectedPatient={formData.patient}
                showFilters={true}
                label="Buscar paciente"
              />
            ) : (
              <Box sx={{ p: 2, bgcolor: '#F0FDF4', borderRadius: 2, border: '1px solid #BBF7D0' }}>
                <Typography variant="body2" fontWeight={700}>{formData.patient.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {formData.patient.species} · {formData.patient.breed} · {formData.patient.genero}
                </Typography>
                {formData.patient.ownerName && (
                  <Typography variant="caption" display="block" color="text.secondary">
                    Propietario: {formData.patient.ownerName}
                  </Typography>
                )}
              </Box>
            )}
          </Grid>

          {/* Aquí se agregarán más campos en el futuro */}
          
          <Grid size={12}>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button
                variant="outlined"
                onClick={() => setFormData({ patient: null, patientId: '' })}
                disabled={saving}
              >
                Limpiar
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={handleSave}
                disabled={saving || !formData.patient}
              >
                {saving ? 'Guardando...' : 'Guardar Caso'}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CasosAmbulatorios;
